// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["__sentryRewritesTunnelPath__"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"sales-pilot-sites-production-release@2025-04-11T22:31:47.127Z"};globalThis["__sentryBasePath"] = undefined;globalThis["__rewriteFramesAssetPrefixPath__"] = "";import { init } from '@sentry/nextjs';
import { getBaseSentryClientConfig } from '@qb/base-config/base-sentry.client.config';

init({
  ...getBaseSentryClientConfig(false),
});
